/** Cookie de primera parte donde vive el historial de eventos vistos
 * recientemente (FR-001). Legible por JS a propósito: el bloque se resuelve en
 * cliente para no marcar como dinámicas las páginas que lo alojan. */
export const COOKIE_NAME = 'recently_viewed_performances'

/** Tope de eventos del historial (FR-008, FR-036). Se aplica tanto al
 * almacenar como al presentar, para que ambos no puedan divergir. */
export const MAX_ITEMS = 15

/** Vigencia de la cookie en días, renovada en cada escritura (FR-020, FR-037). */
export const COOKIE_DAYS = 60

/** Forma canónica de un id de evento. Allow-list: el valor de la cookie es
 * entrada de frontera manipulable por el visitante (Constitución, Principio
 * VIII), así que todo lo que no encaje se descarta en silencio. */
export const PERFORMANCE_ID_PATTERN = /^performance-[A-Za-z0-9-]+$/

/** Prefijo de la forma canónica, usado al normalizar un id que llega sin él. */
export const PERFORMANCE_ID_PREFIX = 'performance-'
